module.exports = __webpack_public_path__ + "static/media/employee_db.aa0e0bb3.webp";